import { render, staticRenderFns } from "./DynamicCohortBuilder.vue?vue&type=template&id=b925aade&scoped=true&"
import script from "./DynamicCohortBuilder.vue?vue&type=script&lang=js&"
export * from "./DynamicCohortBuilder.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCohortBuilder.vue?vue&type=style&index=0&id=b925aade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b925aade",
  null
  
)

export default component.exports